import { Reducer } from 'redux';
import { AuthorisationActionTypes, AuthorisationState } from 'types';
const initialState: AuthorisationState = {
  authorisations: [],
  orders: []
};
const reducer: Reducer<AuthorisationState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case AuthorisationActionTypes.GET_AUTHORISATION_TYPES_SUCCESS: {
      return {
        ...state,
        authorisationTypesOption: action.payload
      };
    }
    case AuthorisationActionTypes.GET_AUTHORISATION_TYPES_FAILURE: {
      return {
        ...state,
        authorisationTypesOption: []
      };
    }
    case AuthorisationActionTypes.LIST_AUTHORISATIONS_START: {
      return {
        ...state,
        authorisationProcess: 'listing',
        authorisationListingError: undefined
      };
    }
    case AuthorisationActionTypes.LIST_AUTHORISATIONS_SUCCESS: {
      const { authorisations, totalAuthorisations } = action.payload;
      return {
        ...state,
        authorisationProcess: undefined,
        authorisationListingError: undefined,
        authorisations,
        totalAuthorisations
      };
    }
    case AuthorisationActionTypes.LIST_AUTHORISATIONS_FAILURE: {
      return {
        ...state,
        processing: undefined,
        authorisationListingError: action.payload
      };
    }
    case AuthorisationActionTypes.CLEAR_ALL_AUTHORISATIONS: {
      return initialState;
    }
    case AuthorisationActionTypes.CLEAR_SELECTED_AUTHORISATION: {
      return {
        ...state,
        selectedAuthorisation: undefined,
        authorisationProcess: undefined,
        authorisationOrderProcess: undefined,
        authorisationListingError: undefined,
        orders: [],
        displayErrorMessage: undefined
      };
    }
    case AuthorisationActionTypes.GET_AUTHORISATION_SUCCESS: {
      return {
        ...state,
        selectedAuthorisation: action.payload,
        loading: false,
        error: null,
        displayErrorMessage: undefined
      };
    }
    case AuthorisationActionTypes.GET_AUTHORISATION_FAILURE: {
      return {
        ...state,
        displayErrorMessage: action.payload
      };
    }
    case AuthorisationActionTypes.ADD_AUTHORISATION_START: {
      return {
        ...state,
        authorisationProcess: 'adding'
      };
    }
    case AuthorisationActionTypes.ADD_AUTHORISATION_SUCCESS: {
      return {
        ...state,
        authorisationProcess: 'addingDone',
        authorisations: [...state.authorisations, action.payload],
        displayErrorMessage: action.payload
      };
    }
    case AuthorisationActionTypes.ADD_AUTHORISATION_FAILURE: {
      return {
        ...state,
        addAuthorisationError: action.payload,
        displayErrorMessage: action.payload,
        authorisationProcess: 'addingFail'
      };
    }
    case AuthorisationActionTypes.ADD_AUTHORISATION_ORDER_START: {
      return {
        ...state,
        authorisationOrderProcess: 'adding'
      };
    }
    case AuthorisationActionTypes.ADD_AUTHORISATION_ORDER_SUCCESS: {
      return {
        ...state,
        authorisationOrderProcess: undefined,
        orders: [...state.orders, action.payload]
      };
    }
    case AuthorisationActionTypes.ADD_AUTHORISATION_ORDER_FAILURE: {
      return {
        ...state,
        addAuthorisationError: action.payload
      };
    }
    case AuthorisationActionTypes.DELETE_AUTHORISATION_ORDER_START: {
      return {
        ...state,
        authorisationOrderProcess: 'deleting',
        displayErrorMessage: undefined
      };
    }
    case AuthorisationActionTypes.DELETE_AUTHORISATION_ORDER_SUCCESS: {
      return {
        ...state,
        authorisationOrderProcess: undefined,
        displayErrorMessage: undefined,
        orders: state.orders.filter(
          (order) => order.id !== action.payload.orderId
        )
      };
    }
    case AuthorisationActionTypes.DELETE_AUTHORISATION_ORDER_FAILURE: {
      return {
        ...state,
        authorisationOrderProcess: undefined,
        displayErrorMessage: action.payload
      };
    }
    case AuthorisationActionTypes.DELETE_AUTHORISATION_SUCCESS: {
      return {
        ...state,
        authorisations: state.authorisations.filter(
          (authorisation) => authorisation.id !== action.payload
        ),
        error: null
      };
    }
    case AuthorisationActionTypes.DELETE_AUTHORISATION_FAILURE: {
      return {
        ...state,
        error: action.payload
      };
    }
    case AuthorisationActionTypes.UPDATE_AUTHORISATION_START: {
      return {
        ...state,
        authorisationProcess: 'updating'
      };
    }
    case AuthorisationActionTypes.UPDATE_AUTHORISATION_SUCCESS: {
      return {
        ...state,
        authorisationProcess: 'updatingDone'
      };
    }
    case AuthorisationActionTypes.UPDATE_AUTHORISATION_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        displayErrorMessage: action.payload,
        authorisationProcess: 'updatingFail'
      };
    }
    case AuthorisationActionTypes.CLEAR_ERROR: {
      return {
        ...state,
        displayErrorMessage: undefined,
        authorisationProcess: 'clearField'
      };
    }
    case AuthorisationActionTypes.PURCHASE_AUTHORISATION_START: {
      return {
        ...state,
        authorisationPurchaseId: undefined,
        authorisationPurchaseQuantity: action.payload.orders[0]?.amount || 1,
        authorisationPurchaseType: action.payload.authorisationType,
        authorisationProcess: 'purchasing'
      };
    }
    case AuthorisationActionTypes.PURCHASE_AUTHORISATION_SUCCESS: {
      return {
        ...state,
        authorisationPurchaseId: action.payload.id,
        authorisationProcess: 'purchasingDone'
      };
    }
    case AuthorisationActionTypes.PURCHASE_AUTHORISATION_FAILURE: {
      return {
        ...state,
        authorisationProcess: 'purchasingFail',
        displayErrorMessage: action.payload
      };
    }
    case AuthorisationActionTypes.PURCHASE_AUTHORISATION_ORDER_START: {
      return {
        ...state,
        authorisationPurchaseId: undefined,
        authorisationPurchaseType:
          state.selectedAuthorisation?.authorisationType,
        authorisationPurchaseQuantity: action.payload.payload.amount || 1,
        authorisationOrderProcess: 'purchasing'
      };
    }
    case AuthorisationActionTypes.PURCHASE_AUTHORISATION_ORDER_SUCCESS: {
      return {
        ...state,
        authorisationOrderProcess: undefined,
        authorisationPurchaseId: action.payload.id
      };
    }
    case AuthorisationActionTypes.PURCHASE_AUTHORISATION_ORDER_FAILURE: {
      return {
        ...state,
        authorisationOrderProcess: undefined,
        displayErrorMessage: action.payload
      };
    }
    case AuthorisationActionTypes.CLEAR_PURCHASE_AUTHORISATION: {
      return {
        ...state,
        authorisationPurchaseId: undefined,
        authorisationPurchaseType: undefined,
        authorisationPurchaseQuantity: undefined,
        authorisationProcess: undefined,
        authorisationOrderProcess: undefined,
        displayErrorMessage: undefined
      };
    }
    default: {
      return state;
    }
  }
};
export { reducer as AuthorisationReducer };
